import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../../../ui/card';
import { CreditSubmission } from '../../../../api/creditSubmissionApi';
import { formatCurrency, formatDate } from './utils';

interface DetailSection5Props {
  submission: CreditSubmission;
}

export default function DetailSection5({ submission }: DetailSection5Props) {
  return (
    <Card>
      <CardHeader>
        <CardTitle>5. Ringkasan SLIK</CardTitle>
      </CardHeader>
      <CardContent>
        <div className="grid md:grid-cols-2 gap-4">
          <div>
            <label className="text-sm text-gray-600">Plafon Efektif</label>
            <p className="font-medium mt-1">{formatCurrency(submission.slik_effective_plafon)}</p>
          </div>
          <div>
            <label className="text-sm text-gray-600">Outstanding</label>
            <p className="font-medium mt-1">{formatCurrency(submission.slik_outstanding)}</p>
          </div>
          <div>
            <label className="text-sm text-gray-600">Kualitas Terburuk</label>
            <p className="font-medium mt-1">{submission.slik_worst_quality || '-'}</p>
          </div>
          <div>
            <label className="text-sm text-gray-600">Bulan Data</label>
            <p className="font-medium mt-1">{submission.slik_data_month || '-'}</p>
          </div>
          <div>
            <label className="text-sm text-gray-600">Tanggal Posisi</label>
            <p className="font-medium mt-1">{formatDate(submission.slik_position_date)}</p>
          </div>
          {submission.slik_document_url && (
            <div className="md:col-span-2">
              <label className="text-sm text-gray-600">Dokumen SLIK</label>
              <div className="mt-1">
                <a
                  href={submission.slik_document_url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-blue-600 hover:underline"
                >
                  Lihat Dokumen
                </a>
              </div>
            </div>
          )}
        </div>
      </CardContent>
    </Card>
  );
}
